module.exports = __webpack_public_path__ + "img/aboutUs_banner_mobile.d233db15.jpg";